import { calculateRemainingLifetimeOfMmsToken } from '../utils';
import { isNumber } from 'lodash';
import { calculateTimestampInMs, safeSetTimeout } from '../../../services/utilityService';
import { setTimeoutId } from '../reducer';
import { updateAllTokens } from './thunksCreators';

/**
 * Thunk creator Thunk that runs the tokens flow, updating all tokens based on the provided expiration timestamp.
 *
 * @param {number} expires - The timestamp when the tokens are valid until.
 * @returns {Function} A Redux thunk.
 */
export const runTokensFlow = (expires) => (dispatch) => {
    const remainingLifetime = calculateRemainingLifetimeOfMmsToken(expires);

    if (!isNumber(remainingLifetime) && !isNumber(expires)) {
        return;
    }

    safeSetTimeout(
        () => dispatch(updateAllTokens(expires)),
        calculateTimestampInMs(remainingLifetime),
        (timeoutId) => dispatch(setTimeoutId(timeoutId)),
    );
};
